(function ($, Drupal, once) {
  function disableScroll() {
    document.body.style.overflow = 'hidden';
  }

  function enableScroll() {
    document.body.style.overflow = '';
  }

  const navOpenClass = 'nav-open';

  // Mobile show filters panel
  Drupal.behaviors.showMobileFilters = {
    attach: function attach(context) {
      $(once('mobile-filter-toggle', '.mobile-filter-toggle', context)).each(
        function () {
          const mobileFilterToggle = $(this);
          const sidebar = $('.sidebar');
          mobileFilterToggle.on('click', () => {
            if (sidebar.hasClass(navOpenClass)) {
              sidebar.removeClass(navOpenClass);
              enableScroll();
            } else {
              sidebar.addClass(navOpenClass);
              disableScroll();
            }
          });
        },
      );
    },
  };

  Drupal.behaviors.updateFilters = {
    attach: function attach(context) {
      const sidebar = $('.sidebar');

      $('.update-filters-button, .close-filters-button', context)
        .off()
        .on('click', () => {
          sidebar.removeClass(navOpenClass);
          enableScroll();
        });
    },
  };
}(jQuery, Drupal, once));
